import { ActionFormWithDescription } from "./ActionFormWithDescription";
import { usePaymentReviewMutation } from "./usePaymentReviewMutation";

interface PaymentReviewApproveActionProps {
  transactionId: number;
  isDepositInReview?: boolean;
  isRemainderInReview?: boolean;
  isPaymentInReview?: boolean;
}

export function PaymentReviewApproveAction({
  transactionId,
  isDepositInReview,
  isRemainderInReview,
  isPaymentInReview,
}: PaymentReviewApproveActionProps) {
  const { submitPaymentReview, isLoading } = usePaymentReviewMutation({
    transactionId,
    approved: true,
    isDepositInReview,
    isRemainderInReview,
    isPaymentInReview,
  });

  const canExecute =
    isDepositInReview || isRemainderInReview || isPaymentInReview;

  return (
    <ActionFormWithDescription
      title="Payment Review - Approve"
      buttonText="Approve payment"
      canExecute={canExecute}
      isLoading={!!isLoading}
      onSubmit={submitPaymentReview}
      dataTestId="payment-review-approve"
    />
  );
}
